import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .controller('IssueLabourCostController', IssueLabourCostController);

    function IssueLabourCostController(
        $scope,
        $rootScope,
        $state,
        CompaniesFactory,
        FormVerificationService,
        LocalStorageService,
        LabourCostsFactory,
        CostsService
    ) {
        var vm = this;
        var companyEmployee;

        init();

        function init() {
            companyEmployee = LocalStorageService.getCompanyEmployee();

            if (vm.cost && vm.cost.id) {
                vm.labour = vm.cost.labour || vm.cost;

                var durationPieces = vm.labour.duration.split(':');
                vm.labour.durationHours = +durationPieces[0];
                vm.labour.durationMinutes = +durationPieces[1];

                vm.labour.description = vm.cost.description;
                vm.labour.visible_to_client = vm.cost.visible_to_client;
            } else {
                vm.labour = {};
                vm.labour.durationMinutes = 0;
                vm.labour.durationHours = 1;
                vm.labour.description = 'Koszt robocizny';
                vm.labour.hourly_rate = 0;
            }

            vm.shouldDisplayCostValues = shouldDisplayCostValues;
            vm.hours = makeHoursList();
            vm.minutes = [0, 15, 30, 45];
            vm.changeHourlyRate = changeHourlyRate;
            vm.addCost = addCost;
            vm.updateCost = updateCost;
            vm.cancelCost = cancelCost;

            getUsers();
            fillGrossValue();
            fixMinutes();
        }

        function getUsers() {
            CompaniesFactory.readEmployees(
                companyEmployee.organization.party_uuid,
                {
                    page_size: 1000,
                }
            ).then(function (response) {
                vm.contractors = response.data.results;
                vm.contractors.forEach(function (user) {
                    if (user.first_name && user.last_name) {
                        user.displayName =
                            user.first_name + ' ' + user.last_name;
                    } else {
                        user.displayName = user.username;
                    }
                });
            });
        }

        function shouldDisplayCostValues(): boolean {
            return companyEmployee.manager;
        }

        function changeHourlyRate() {
            if (vm.labour.user) {
                vm.labour.hourly_rate = vm.contractors.find(function (
                    contractor
                ) {
                    return contractor.user === vm.labour.user;
                }).hourly_rate;

                if (!vm.labour.hourly_rate) {
                    vm.labour.hourly_rate = 0;
                }
            }
        }

        function addCost() {
            vm.labour.duration = parsedTime();
            LabourCostsFactory.create(
                companyEmployee.organization.party_uuid,
                vm.issue.id,
                vm.labour
            ).then(
                function (response) {
                    $rootScope.$broadcast('cost-added', response.data);
                    refreshIssue();
                    cancelCost();
                },
                function (error) {
                    FormVerificationService.error(error.data, vm.form);
                }
            );
        }

        function updateCost() {
            vm.labour.duration = parsedTime();
            LabourCostsFactory.update(
                companyEmployee.organization.party_uuid,
                vm.issue.id,
                vm.cost.id,
                vm.labour
            ).then(
                function (response) {
                    $rootScope.$broadcast(
                        'cost-changed',
                        Object.assign(vm.cost, response.data)
                    );
                    refreshIssue();
                    cancelCost();
                },
                function (error) {
                    FormVerificationService.error(error.data, vm.form);
                }
            );
        }

        function cancelCost() {
            if (vm.cost && vm.cost.labour) {
                vm.labour = vm.cost.labour;
            } else {
                vm.labour = {};
            }
            $scope.$parent.$parent.ChangeCostsCtrl.isUserAddingCost = false;
        }

        function fillGrossValue() {
            $scope.$watch(
                function () {
                    return vm.labour;
                },
                function () {
                    vm.labour.gross_value =
                        CostsService.calculateLabourGrossValue(
                            parsedTime(),
                            vm.labour.hourly_rate
                        );
                },
                true
            );
        }

        function parsedTime() {
            return (
                vm.labour.durationHours.toString() +
                ':' +
                vm.labour.durationMinutes.toString() +
                ':00'
            );
        }

        function fixMinutes() {
            if (!vm.minutes.includes(vm.labour.durationMinutes)) {
                vm.minutes.push(vm.labour.durationMinutes);
                vm.minutes.sort();
            }
        }

        function refreshIssue() {
            $state.reload('company_employee.issue_list.details');
        }

        function makeHoursList() {
            var tmpList = [];
            for (var i = 0; i <= 23; i++) {
                tmpList.push(i);
            }

            return tmpList;
        }
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/issues/company_issue_list/details/change-costs/issue-labour-cost/issue-labour-cost.controller.ts